import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import footer_logo from "../../assets/images/footer-logo.png";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const Footer = () => {
  const scrollToSection = (id: string) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="footer">
      <Container fixed>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <Item className="remove-item-css">
                <div className="footer-text">
                  <p>
                    Conscisys Corporation provides IT systems design,
                    programming, project management and web development services
                    to a variety of business and government organizations
                  </p>

                  <div className="footer-logo">
                    <p className="powered-by">Powered by</p>
                    <img src={footer_logo} alt="Conscisys" width="100" />
                  </div>
                </div>
              </Item>
            </Grid>
            <Grid item md={4} sm={6}>
              <Item className="remove-item-css">
                <div className="footermenu">
                  <p className="mb-4 h4">Know more About Us</p>
                  <ul className="mt-3">
                    <li className="mb-2">
                      <span
                        role="button"
                        className="cursor-pointer"
                        onClick={() => scrollToSection("aboutus")}
                      >
                        About Us
                      </span>
                    </li>
                    <li className="mb-2">
                      <span
                        role="button"
                        className="cursor-pointer"
                        onClick={() => scrollToSection("features")}
                      >
                        Features
                      </span>
                    </li>
                    <li className="mb-2">
                      <span
                        role="button"
                        className="cursor-pointer"
                        tabIndex={0}
                        onClick={() => window.open("https://conscisys.com/accessibility-statement/", "_blank")}
                        aria-label="Accessibility Statement"
                      >
                        Accessibility Statement
                      </span>
                    </li>
                  </ul>
                </div>
              </Item>
            </Grid>
            <Grid item md={4} sm={6}>
              <Item className="remove-item-css">
                <div className="contact-dtl">
                  <p className="mb-4 h4">Connect with us</p>
                  {/* <ul className="contact-left-border ps-3"> */}
                  {/* <li className="mb-2"><FontAwesomeIcon className="me-2" icon={faHeadphones} />+1-202-555-0152</li> */}
                  {/* <li className="mb-2">
                      <FontAwesomeIcon className="me-2" icon={faEnvelope} />
                      <i className="fa-solid fa-envelope"></i>Support@i2file.net
                    </li> */}
                  {/* <li className="mb-2">
                      CONSCISYS Corporation<br/> 1125 Mistwood Place,<br/> Downers Grove,
                      IL<br/> 60515-1205
                    </li> */}
                  {/* </ul> */}
                  <Box pl={8}>
                    <Button
                      href="https://support.conscisys.com/support/"
                      target="_blank"
                      className="btn primary-button"
                      variant="contained"
                      aria-label="Conscisys Support"
                    >
                      Support
                    </Button>
                  </Box>
                </div>
              </Item>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </footer>
  );
};

export default Footer;
